module.exports = __webpack_public_path__ + "img/atBat.bd322630.jpeg";